import { plural, type Translate } from '../i18n/plural';
import type { SharedBySummary } from '../types/api';

// #1693: a drone page shows every flight the caller may see, own and shared, and
// every shared row says whose it is. The backend stamps `shared` and
// `shared_by_organization_name` on each row; these helpers turn that into the
// one set of words every drone-page surface uses.

/** "Shared by <org>" for a shared row, `null` for the caller's own. */
export function sharedByLabel(
  t: Translate,
  row: { shared?: boolean; shared_by_organization_name?: string | null }
): string | null {
  if (!row.shared) return null;
  return row.shared_by_organization_name
    ? t('dronePageShared.sharedBy', { org: row.shared_by_organization_name })
    : t('dronePageShared.sharedByUnknown');
}

/** The sharing organizations, named once each, in the order given. */
export function sharedOrgList(t: Translate, names: Array<string | null | undefined>): string {
  const known = Array.from(new Set(names.filter((n): n is string => !!n)));
  if (known.length === 0) return t('dronePageShared.sharedByUnknown');
  return known.join(', ');
}

/** The note under the profile's counters: they include N shared flights, by whom. */
export function sharedCountersNote(
  t: Translate,
  sharedFlights: number | undefined,
  sharedBy: SharedBySummary[] | undefined
): string | null {
  if (!sharedFlights) return null;
  return plural(
    t,
    sharedFlights,
    {
      one: 'dronePageShared.countersIncludeSharedOne',
      other: 'dronePageShared.countersIncludeSharedOther',
    },
    {
      orgs: sharedOrgList(
        t,
        (sharedBy ?? []).map((s) => s.organization_name)
      ),
    }
  );
}
